<ng-template [ngIf]="isUploadingFile">
  <app-loading></app-loading>
</ng-template>
   <div class="d-flex mt-2">
        <div class="grid formgrid p-fluid">
            
          <div class="field mt-2 mb-2 col-12">
          <p-fileUpload 
                mode="basic" 
                name="caricaFile"
                multiple="false"
                maxFileSize="5000000000"
                [accept]="acceptedFileTypes"
                [auto]="false"
                chooseLabel="{{label}}"
                chooseIcon="{{icona}}"
                uploadIcon="{{icona}}"
                uploadLabel="{{label}}"
                [styleClass]="fileClass"
                (onUpload)="onFileUpload($event)" 
                (onSelect)="onFileSelect($event)" 
                url="https://www.primefaces.org/cdn/api/upload.php"
            >
          </p-fileUpload>
      </div>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
     <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isUploadingFile || !files"></p-button>
  </div>
    <p-toast />
    <p-confirmDialog /> 